import request from '@/utils/request'

// 查询His系统报告单项指标列表
export function listHisDiagnosticReportObservation(query) {
    return request({
        url: '/his/hisDiagnosticReportObservation/list',
        method: 'get',
        params: query
    })
}

export function listAllHisDiagnosticReportObservation(query) {
    return request({
        url: '/his/hisDiagnosticReportObservation/listAll',
        method: 'get',
        params: query
    })
}

// 查询His系统报告单项指标详细
export function getHisDiagnosticReportObservation(id) {
    return request({
        url: '/his/hisDiagnosticReportObservation/' + id,
        method: 'get'
    })
}

// 新增His系统报告单项指标
export function addHisDiagnosticReportObservation(data) {
    return request({
        url: '/his/hisDiagnosticReportObservation',
        method: 'post',
        data: data
    })
}

// 修改His系统报告单项指标
export function updateHisDiagnosticReportObservation(data) {
    return request({
        url: '/his/hisDiagnosticReportObservation/update',
        method: 'post',
        data: data
    })
}

// 删除His系统报告单项指标
export function delHisDiagnosticReportObservation(id) {
    return request({
        url: '/his/hisDiagnosticReportObservation/delete/' + id,
        method: 'post'
    })
}
